import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Tooltip } from "reactstrap";
import Icon from "../../../../components/UI/Icon";
import Loading from "../../../../components/UI/Loading";
import { reportKeyMap } from "../../../../dictionaries/reportKeyMap";
import { formatDate } from "../../../../helpers/date";
import { getSegments, Segment } from "../../../../helpers/segments";
import { ReportSummaryResponse } from "../../../../services/reportsSummaryGet";
import { ReportSummaryState } from "../../../../store/reportSummary/types";
import { AppState } from "../../../../store/store";
import Product from "./Product";
import styles from "./ProductsFree.module.scss";

export type Product =
  | "accounts"
  | "credit-card"
  | "credit"
  | "contracts-services";

interface Props {
  product: Product;
  overdue: boolean;
  reportSummaryState: ReportSummaryState;
}

const ProductsFree = ({ product, overdue, reportSummaryState }: Props) => {
  const [date, setDate] = useState("");
  const [message, setMessage] = useState("");
  const [products, setProducts] = useState(0);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [segments, setSegments] = useState<Segment[]>([]);
  const getProducts = (reportSummary: ReportSummaryResponse, product: Product) => {
    const key = reportKeyMap[product];
    const products = reportSummary[key] || [];
    return products.length;
  }
  const handleClick = () => {
    const element = document.getElementById("no_subscription_card");
    if (element) {
      const yCoordinate = element.getBoundingClientRect().top + window.pageYOffset;
      const yOffset = -72;

      window.scrollTo({
        top: yCoordinate + yOffset,
        behavior: "smooth"
      });
    }
  }

  useEffect(() => {
    if (reportSummaryState.status === "loaded") {
      const { payload } = reportSummaryState;
      const { date, accountDetail } = payload;
      const calculatedSegments = getSegments(accountDetail || {});
      setSegments(calculatedSegments)
      setDate(date);
      setProducts(getProducts(payload, product));
      setMessage(`
        El número de productos está basado en una consulta del 
        ${formatDate(date, { in: "DD/MM/YYYY HH:mm:ss" })}. 
        Puede que la información que veas esté desactualizada.
      `);
    }
  }, [reportSummaryState.status]);

  if (reportSummaryState.status === "loading")
    return <Loading />

  if (reportSummaryState.status === "loaded" || reportSummaryState.status === "updating") {
    return (
      <div className={styles.container}>
        {product === "accounts" && segments.length > 0 ?
          (<>
            {segments.map(({ key, label, upToDate }) => (
              <div
                key={key}
                className={styles.container}
              >
                <div className={styles.header}>
                  <p className={styles.title}>
                    {label}
                  </p>
                </div>
                {(upToDate || []).map((product, i) => <Product key={i} product={product} closed={key === "closed"} />)}
              </div>
            ))}
            {products - 1 > 0 && (
              <div className={styles.ctaContainer}>
                <p className={styles.ctaText}>
                  Para ver los detalles de tus otros{' '}
                  <strong>{products - 1} productos</strong> y entender cómo impactan tu
                  score, accede a tu reporte completo.{" "}
                  <span className={styles.callAction} onClick={handleClick}>Ver toda mi información</span>
                </p>
              </div>
            )}
          </>) :
          (<div className={styles.ctaContainerDown}>
            <div className={styles.grid}>
              <p className={styles.description}>
                {overdue && "Presentas productos en mora. "}
                ¿Quieres saber cuáles y cómo afectan tu puntaje?&nbsp;{" "}
                <span className={styles.callAction} onClick={handleClick}>Ver toda mi información</span>
              </p>
            </div>
            {date && (
              <div>
                <Icon
                  id={`${product}-product`}
                  icon="info"
                  className={styles.icon}
                />
                <Tooltip
                  target={`${product}-product`}
                  placement="left"
                  isOpen={tooltipOpen}
                  toggle={() => setTooltipOpen(!tooltipOpen)}
                >
                  {message}
                </Tooltip>
              </div>
            )}
          </div>)}
      </div>
    )
  }

  return <></>
}

const mapStateToProps = (state: AppState) => ({
  reportSummaryState: state.reportSummary,
});

export default connect(mapStateToProps)(ProductsFree);